/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React from "react";
import {NavLink} from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Constants";
import Swal from 'sweetalert2'
import Logo from './../../Assets/image/Logo.png'

const Nav = ()=>{
    const logout = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You Will Be Logged Out",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Logout'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(BASEURL+'/api/client/logout').then(res=>{
                    localStorage.removeItem('name')
                    localStorage.removeItem('admin_token')
                    localStorage.removeItem('email')
                    window.location.reload();
                })
            }
        })
    }
    return(
        <>
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                {/*Navbar Brand*/}
                <NavLink to={'/'} className="navbar-brand ps-3" ><img src={Logo} alt={'Mega Hot Mop Logo'} className={'img-fluid p-3 ps-0'}/> </NavLink>
                {/*Sidebar Toggle*/}
                <button className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" href="#!"><i
                    className="fas fa-bars"/></button>
                {/*Navbar Search*/}

                {/*Navbar*/}
                <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4 position-absolute end-0">
                    <li className={'text-white mt-2'}>Welcome! {localStorage.name != undefined? localStorage.name : null}</li>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" id="navbarDropdown" href="/" role="button"
                           data-bs-toggle="dropdown" aria-expanded="false"><i className="fas fa-user fa-fw"/></a>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                            <li><button className={'dropdown-item'} onClick={logout}>Logout</button></li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </>
    )
}
export default Nav